export const err = (inMsg: string) => {
  let msg = inMsg;
  if (!msg) {
    msg = 'Sorry, an error occured. Please try again later.';
  }
  throw new Error(msg);
};
